/**
 * Root-level defaults for document metadata (`index.tsx`). About page and other CMS-driven
 * routes fall back to these when page-specific SEO fields are absent.
 *
 * The default title already includes the "Workday Developers" brand, so consumers should
 * render it through `<DevsiteMetadata useExactTitle />` to avoid the automatic
 * " | Workday Developers" suffix being appended a second time.
 */
export const DEVSITE_ROOT_DEFAULT_PAGE_TITLE = 'Workday Developers | Build on the Workday Platform';

export const DEVSITE_ROOT_DEFAULT_DESCRIPTION =
  'Join the Workday Build developer program and build high-impact, enterprise-ready AI solutions alongside a thriving developer community.';

export const DEVSITE_ROOT_DEFAULT_SOCIAL_IMAGE = '/public/static/media/wcp-192.png';
